var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"connectorScreen"}},[_c('loan-calculator-header'),_c('content-spinner',{attrs:{"show":_vm.loading}}),(!_vm.loading)?_c('div',{staticClass:"page-content p-4",attrs:{"id":"pageContent"}},[_c('calculators-list'),_c('folders-list')],1):_vm._e(),_c('AddEditCalculatorModal',{on:{"update":_vm.onUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }